export default "__VITE_ASSET__COdvct7A__"